global.config = {
    url: "https://www.newgrand.cn",
    serverUrl: "https://gateway.ns820.com/newgrandCms"
};